import Keycloak from "keycloak-js";
import Cookie from "js-cookie";

import { OAUTH_URL, REALM, CLIENT_ID } from "customGlobal";

export const COOKIE_TOKEN = "crm-token";
export const COOKIE_TOKEN_REFRESH = "crm-token-refresh";
export const COOKIE_APP_ID = "crm-token-id";

const auth = new Keycloak({
  clientId: CLIENT_ID(),
  realm: REALM(),
  url: OAUTH_URL(),
});

auth.onTokenExpired = () => {
  updateToken();
};

export function initAuth() {
  return auth
    .init({
      onLoad: "login-required",
      checkLoginIframe: window.location.protocol === "https:",
      // on utilise l'ancien token en premier lors de l'initialisation
      // pour éviter une redirection si tout est bon.
      token: Cookie.get(COOKIE_TOKEN),
      refreshToken: Cookie.get(COOKIE_TOKEN_REFRESH),
      idToken: Cookie.get(COOKIE_APP_ID),
      timeSkew: 0,
    })
    .then((authenticated: boolean) => {
      if (authenticated) {
        updateCookie();
      }
      return authenticated;
    })
    .catch(() => {
      resetCookie();
      return false;
    });
}

export async function updateToken() {
  try {
    const refreshed = await auth.updateToken(5);
    if (refreshed) {
      updateCookie();
    }
    return refreshed;
  } catch {
    return auth.token;
  }
}

function updateCookie() {
  // on sauvegarde en STRICT dans les cookies le token + token refresh.
  Cookie.set(COOKIE_TOKEN, auth.token || "", { expires: 1, sameSite: "strict" });
  Cookie.set(COOKIE_TOKEN_REFRESH, auth.refreshToken || "", {
    expires: 1,
    sameSite: "strict",
  });
  Cookie.set(COOKIE_APP_ID, auth.idToken || "", { expires: 1, sameSite: "strict" });
}

function resetCookie() {
  // on sauvegarde en STRICT dans les cookies le token + token refresh.
  Cookie.remove(COOKIE_TOKEN);
  Cookie.remove(COOKIE_TOKEN_REFRESH);
  Cookie.remove(COOKIE_APP_ID);
}

/**
 * Méthode de déconnexion de l'application
 * - on revoke le token d'authentification
 * -
 */
export function disconnect() {
  sessionStorage.clear();
  resetCookie();
  auth.logout();
}

export function reconnect() {
  sessionStorage.clear();
  resetCookie();
  auth.login();
}

export function getAccountURI() {
  return auth.createAccountUrl();
}

if (import.meta.env.DEV) (window as any).auth = auth;

export default auth;
